import { TrialData } from '../../types/api';
import { Serializable } from '../lib/Serializable';

type SerializeTrialData = TrialData & {
  timestamp: number;
};

export class Trial implements Serializable<SerializeTrialData> {
  protected readonly data: TrialData;
  created = Date.now();

  constructor(data: TrialData) {
    this.data = data;
  }

  get<K extends keyof TrialData>(key: K): TrialData[K] {
    return this.data[key];
  }

  serialize(): SerializeTrialData {
    return {
      ...this.data,
      timestamp: this.created,
    };
  }
}
